import ExternalStorageBaseScreen from "./shared/externalStorage/ExternalStorageBaseScreen";

export const ExternalStorageBase = () => <ExternalStorageBaseScreen variant="mapping" />;
